import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { MAINTENANCE_END_TIME } from '../config/maintenance.constants';
import {
  dismissMaintenanceBanner,
  isMaintenanceBannerDismissed,
} from './maintenanceBannerDismissal';

/**
 * Drives the visibility of the maintenance banner in the authenticated layout. Starts hidden, and on mount, unless the maintenance window has already ended, shows the banner when no matching dismissal is stored.
 *
 * @returns The banner visibility flag and the callback that closes it.
 */
export const useMaintenanceBanner = () => {
  const [isShowMaintenanceBanner, setIsShowMaintenanceBanner] = useState(false);

  useEffect(() => {
    // No timer at the end time: the page is reloaded after maintenance anyway.
    if (!dayjs().isBefore(MAINTENANCE_END_TIME)) {
      return;
    }
    isMaintenanceBannerDismissed().then((isDismissed) => setIsShowMaintenanceBanner(!isDismissed));
  }, []);

  /**
   * Closes the maintenance banner at the user's request. Hides it immediately, then stores the dismissal without awaiting it.
   *
   * @returns Nothing.
   */
  const closeMaintenanceBanner = () => {
    setIsShowMaintenanceBanner(false);
    dismissMaintenanceBanner();
  };

  return { isShowMaintenanceBanner, closeMaintenanceBanner };
};
